/**
 * Whether a given object has any "truthy" values.
 * Note this means that if the only values that
 * are defined are 'false' or 0 etc. then this will
 * return true.
 */
export function isEmpty(item: object): boolean {
    return Object.keys(item).every(key => !(item as any)[key]);
}
